/** @typedef {'license_tracking' | 'licensing_tool' | 'event_management'} LicensingExperienceMode */

export const LICENSE_TRACKING_PLATFORM_TITLE = 'License Tracking System';
export const LICENSING_TOOL_PLATFORM_TITLE = 'Licensing Tool Platform';
export const EVENT_MANAGEMENT_PLATFORM_TITLE =
  'IQVIA Healthcare Workflow Management Solution';

export const LICENSE_TRACKING_PLATFORM_DESCRIPTION =
  'A centralized platform to manage, track, and validate healthcare professionals\u2019 licenses across specialties and geographies\u2014ensuring regulatory compliance, operational efficiency, and data accuracy through automated workflows, bulk operations, and real-time status visibility.';

export const LICENSING_TOOL_PLATFORM_DESCRIPTION =
  'The Licensing Tool Platform streamlines healthcare licensing with automated workflows, real-time tracking, and compliance-driven processes, delivering efficiency and transparency across all stages.';

export const EVENT_MANAGEMENT_PLATFORM_DESCRIPTION =
  'is an enterprise-grade workflow automation platform that enables healthcare organizations to efficiently manage complex operational, administrative, regulatory, and clinical support processes. Through configurable workflows, centralized governance, automated notifications, SLA tracking, integrated reporting, and comprehensive audit trails, organizations can improve productivity, strengthen compliance, and deliver faster, more consistent outcomes.';

/**
 * Short product-experience label for navbar (beside logo).
 * e.g. license_tracking → "License Tracking System"; event_management uses the full platform title
 *
 * @param {LicensingExperienceMode | null | undefined} mode
 * @returns {string}
 */
export function getProductExperienceLabel(mode) {
  if (mode === 'event_management') {
    return EVENT_MANAGEMENT_PLATFORM_TITLE;
  }
  const normalized =
    mode === 'licensing_tool' || mode === 'event_management'
      ? mode
      : 'license_tracking';
  const label = normalized
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
  return `${label} System`;
}

/**
 * @param {LicensingExperienceMode | null | undefined} mode
 */
export function getPlatformBranding(mode) {
  if (mode === 'licensing_tool') {
    return {
      title: LICENSING_TOOL_PLATFORM_TITLE,
      description: LICENSING_TOOL_PLATFORM_DESCRIPTION,
    };
  }
  if (mode === 'event_management') {
    return {
      title: EVENT_MANAGEMENT_PLATFORM_TITLE,
      description: EVENT_MANAGEMENT_PLATFORM_DESCRIPTION,
    };
  }
  return {
    title: LICENSE_TRACKING_PLATFORM_TITLE,
    description: LICENSE_TRACKING_PLATFORM_DESCRIPTION,
  };
}
